/*
 * theme-toggle
 */
import { Button } from "@emr/react-ui"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "../hooks/use-theme"

export function ThemeToggle() {
	const { theme, setTheme } = useTheme()

	function toggleTheme() {
		setTheme(theme === "dark" ? "light" : "dark")
	}

	return (
		<Button
			className={"relative"}
			variant="outline"
			size="icon"
			onClick={toggleTheme}
		>
			<Sun className="h-[1.2rem] w-[1.2rem] scale-100 transition-all dark:scale-0" />
			<Moon className="absolute h-[1.2rem] w-[1.2rem] scale-0 transition-all dark:scale-100" />
			<span className="sr-only">Toggle theme</span>
		</Button>
	)
}
